var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8219 9.1616C28.0666 7.37548 26.9848 5.77123 25.6076 4.39363C24.23 3.01603 22.6257 1.93461 20.8396 1.17923C18.9898 0.396742 17.0253 0 15.0004 0C12.9754 0 11.011 0.396742 9.1616 1.17884C7.37548 1.93422 5.77123 3.01603 4.39363 4.39323C3.01603 5.77083 1.93461 7.37509 1.17923 9.16121C0.396742 11.011 0 12.9754 0 15.0004C0 17.0253 0.396742 18.9898 1.17884 20.8392C1.93422 22.6253 3.01603 24.2296 4.39323 25.6072C5.77083 26.9848 7.37509 28.0662 9.16121 28.8216C11.0106 29.6037 12.975 30.0004 15 30.0004C17.025 30.0004 18.9894 29.6037 20.8388 28.8216C22.6249 28.0662 24.2292 26.9844 25.6068 25.6072C26.9844 24.2296 28.0658 22.6253 28.8212 20.8392C29.6033 18.9898 30 17.0253 30 15.0004C30 12.9754 29.604 11.011 28.8219 9.1616Z",
    fill: "#00A86B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8553 9.73877C20.5057 9.73877 20.1773 9.87468 19.931 10.121L12.9484 17.1036L10.0706 14.2259C9.82352 13.9772 9.49435 13.8405 9.14474 13.8405C8.79514 13.8405 8.46596 13.9772 8.21927 14.2255C7.97258 14.4722 7.83667 14.8006 7.83667 15.1502C7.83667 15.4998 7.97258 15.8282 8.21888 16.0745L12.0245 19.8801C12.2711 20.1263 12.5991 20.2623 12.9488 20.2623C13.2984 20.2623 13.6267 20.1263 13.873 19.8801L21.78 11.9731C22.029 11.7241 22.1657 11.3941 22.1653 11.0441C22.165 10.6957 22.0283 10.3681 21.7804 10.1218C21.5337 9.87508 21.2053 9.73916 20.8557 9.73916L20.8553 9.73877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.7834b4fe7133e8d5b427e412d4a5533e.svg";
export { ForwardRef as ReactComponent };